module.exports = __webpack_public_path__ + "img/hlwyy_charact_3.c4ef72cd.svg";